import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';

import { css } from '@flipster/styled-system/css';
import { flex, hstack, stack } from '@flipster/styled-system/patterns';

import { meetMasterTraderBunja } from '../state';
import { filterPortfolios, sortPortfolios } from '../utils';
import { PeriodDropdown } from './period-dropdown';
import { SearchInput } from './search-input';
import { SortDropdown } from './sort-dropdown';

export const MeetMasterTraderToolbar = () => {
  const { portfoliosAtom, searchQueryAtom, sortKeyAtom, periodAtom } = useBunja(meetMasterTraderBunja);
  const portfolios = useAtomValue(portfoliosAtom);
  const [searchQuery, setSearchQuery] = useAtom(searchQueryAtom);
  const [sortKey, setSortKey] = useAtom(sortKeyAtom);
  const [period, setPeriod] = useAtom(periodAtom);
  const suggestions = sortPortfolios(filterPortfolios(portfolios, searchQuery), 'roi', '30d');

  return (
    <div
      className={css(stack.raw({ gap: 12, w: '100%' }), {
        tablet: flex.raw({
          direction: 'row',
          justify: 'space-between',
          alignItems: 'flex-start',
          gap: 16,
        }),
      })}
    >
      <div className={hstack({ gap: 8, flexShrink: 0 })}>
        <SortDropdown sortKey={sortKey} onChange={setSortKey} />
        <PeriodDropdown period={period} onChange={setPeriod} />
      </div>
      <SearchInput value={searchQuery} onChange={setSearchQuery} suggestions={suggestions} />
    </div>
  );
};
